import React, { useState } from "react";
import Input from "../../components/Input/Input";
import BackButton from "../../components/BackButton/BackButton";
import Button from "../../components/Button/Button";
import "./styles.css";

const UserData = ({ onSubmit, onBack }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailError, setEmailError] = useState(""); // Estado para el error del email
  const [phoneError, setPhoneError] = useState(""); // Estado para el error del celular
  const tagend = window.tagend;

  const validateEmail = (value) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value.match(emailRegex)) {
      setEmailError("Introduce un correo electrónico válido.");
    } else {
      setEmailError("");
    }
  };

  const validatePhone = (value) => {
    const phoneRegex = /^[0-9]{10,}$/;
    if (!value.match(phoneRegex)) {
      setPhoneError("El número de celular debe tener al menos 10 dígitos.");
    } else {
      setPhoneError("");
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    validateEmail(event.target.value); 
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
    validatePhone(event.target.value); 
  };

  const isFormValid = emailError === "" && phoneError === "" && email.trim() !== "" && phone.trim() !== "";

  const handleSubmit = () => {
    if (isFormValid) {
      onSubmit({ email, phone });
      if (window.plausible) {
        window.plausible(`contact-data-received${tagend}`);
      } else {
        console.error("Plausible is not defined");
      }
    }
  };

  return (
    <div className="user-data-container">
      <h1>Datos de contacto</h1>
      
      <Input
        placeholder="Ingresa tu correo electrónico"
        label="Correo electrónico"
        value={email}
        type="email"
        onChange={handleEmailChange}
      />
      {emailError && <p className="error-message">{emailError}</p>}

      <Input
        placeholder="Ingresa tu número de celular"
        label="Celular"
        type="tel"
        value={phone}
        onChange={handlePhoneChange}
      />
      {phoneError && <p className="error-message">{phoneError}</p>}

      <Button 
        className="buttonUserData"
        type={isFormValid ? "black" : "disabled"} 
        onClick={handleSubmit} 
        disabled={!isFormValid}
      >
        Continuar
      </Button>

      <BackButton onClick={onBack} />
    </div>
  );
};

export default UserData;
